module.exports = __webpack_public_path__ + "img/i_o_my_power.22badd95.svg";